export const resultsData = [
  {
    tile: "",
    minPercentage: 96,
    maxPercentage: 100,
    percentage: "96-100%",
    awakeness: "Awake",
    perspective: "Awakened",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-awareness-YlevljgyZ8ig1rbN.jpg",
  },
  {
    tile: "",
    minPercentage: 81,
    maxPercentage: 95.9999,
    percentage: "81-95%",
    awakeness: "Almost Awake",
    perspective: "Seeker",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-infinite-being-AzGeL9grl5cVnGJO.jpg",
  },
  {
    tile: "",
    minPercentage: 61,
    maxPercentage: 80.9999,
    percentage: "61-80%",
    awakeness: "Awakening",
    perspective: "Seeker",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-connectedness-A0xwOqzwW9hp0zky.jpg",
  },
  {
    tile: "",
    minPercentage: 41,
    maxPercentage: 60.9999,
    percentage: "41-60%",
    awakeness: "Seeking",
    perspective: "Seeker",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-balance-A0xwOqzwvGF2ELPX.jpghttps://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-present-time-dJo6LVQ6bnSG445a.jpg",
  },
  {
    tile: "",
    minPercentage: 21,
    maxPercentage: 40.9999,
    percentage: "21-40%",
    awakeness: "Waking Up",
    perspective: "Sleeping Soul",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-spirit-energy-mv0DBerDPDHVy628.jpg",
  },
  {
    tile: "",
    minPercentage: 0,
    maxPercentage: 20.9999,
    percentage: "0-20%",
    awakeness: "Asleep",
    perspective: "Sleeping Soul",
    illustration:
      "https://assets.zyrosite.com/mP47Mwo0WQhVBkl5/esa44-heart-energy-m5KwEjzaqwcKrbeD.jpg",
  },
];
